<button mat-button [disabled]="disabled" (click)="onClick()">
  {{ text }}
</button>
